import { render, staticRenderFns } from "./MasterPartnerAndShipper.vue?vue&type=template&id=6e5157ae&"
import script from "./MasterPartnerAndShipper.vue?vue&type=script&lang=js&"
export * from "./MasterPartnerAndShipper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports